import {ApplicationConfig, ErrorHandler} from '@angular/core';
import {provideRouter, Router} from '@angular/router';
import {provideStore} from '@ngxs/store';
import {SessionState} from 'src/app/shared/state/session/session.state';
import {DarkwebState} from 'src/app/modules/dark-web/state/darkweb.state';
import {CtaState} from 'src/app/shared/state/cta/cta.state';
import {CreditReportState} from 'src/app/shared/state/credit-report/credit-report-state.service';
import {EventState} from 'src/app/shared/state/calendly/events.state';
import {RentReportingState} from 'src/app/modules/rent-reporting/state/rent-reporting.state';
import {environment} from 'src/environments/environment';
import {withNgxsStoragePlugin} from '@ngxs/storage-plugin';
import {appErrorFactory, AppErrorHandler} from 'src/app/shared/errors/app-error-handler.service';
import * as Sentry from '@sentry/angular';
import {PORTAL_CONFIG, PortalConfig} from 'src/app/shared/config/portal-config';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {LoadIndicatorInterceptor} from 'src/app/core/interceptor/loadindicator.interceptor';
import {AuthSanctumInterceptor} from 'src/app/core/interceptor/auth-sanctum.interceptor';
import {LogoutOnUnauthInterceptor} from 'src/app/core/interceptor/logout-on-unauth.interceptor';
import {ServerErrorInterceptor} from 'src/app/core/interceptor/server-error.interceptor';
import {Reload419Interceptor} from 'src/app/core/interceptor/reload-419.interceptor';
import {provideNgxWebstorage, withLocalStorage, withSessionStorage} from 'ngx-webstorage';
import {provideAnimations} from '@angular/platform-browser/animations';
import {routes} from 'src/app/app-routes';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideStore([
      SessionState, DarkwebState, CtaState, CreditReportState, EventState, RentReportingState,
    ], { developmentMode: !environment.production }),
    withNgxsStoragePlugin({
      keys: ['session.token'],
    }),
    provideRouter(routes),
    // Use our custom AppErrorHandler to process Angular errors
    {provide: ErrorHandler, useFactory: appErrorFactory},
    // Alias AppErrorHandler to the ErrorHandler token so we can inject AppErrorHandler and configure it
    {provide: AppErrorHandler, useExisting: ErrorHandler},
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: PORTAL_CONFIG,
      useValue: PortalConfig,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadIndicatorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthSanctumInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LogoutOnUnauthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Reload419Interceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideNgxWebstorage(withLocalStorage(), withSessionStorage()),
    provideAnimations(),
    provideCharts(withDefaultRegisterables()),
  ],
};
